import { render } from "./DocumentClassListView.vue?vue&type=template&id=0517a98e&ts=true"
import script from "./DocumentClassListView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassListView.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__